import React from "react";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { ArrayInput, SimpleFormIterator, required, NumberInput, useSimpleFormIteratorItem } from "react-admin";
import { useWatch } from "react-hook-form";
import CustomDateTimeInput from "server/components/Fields/CustomDateTimeInput";
import IndexField from "components/Educations/Specialities/ScoreFormula/IndexField";
import { settings } from "app";

const toDateOnly = value => {
  if (!value) return null;
  const d = new Date(value);
  if (isNaN(d)) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

const RankingFields = ({ isDisabled }) => {
  const { index } = useSimpleFormIteratorItem();

  const rankings = useWatch({ name: "rankings" });
  const exams = useWatch({ name: "exams" });
  const registrationToDate = useWatch({ name: "registrationTo" });
  const row = rankings?.[index];

  const rankingDate = toDateOnly(row?.rankingDate);
  const enrollmentStartDate = toDateOnly(row?.enrollmentStartDate);
  const enrollmentEndDate = toDateOnly(row?.enrollmentEndDate);
  const registrationTo = toDateOnly(registrationToDate);

  const prevEnrollmentEndDate = index > 0 ? toDateOnly(rankings?.[index - 1]?.enrollmentEndDate) : null;
  const lastExam =
    exams?.[exams.length - 1]?.examDays?.[exams[exams.length - 1]?.examDays.length - 1]?.examStartTimestamp;
  const lastExamStartTimestamp = toDateOnly(lastExam);

  return (
    <>
      <IndexField />

      <NumberInput
        source="id"
        sx={{ display: "none" }}
        defaultValue={0}
        readOnly
      />
      <NumberInput
        source="status"
        sx={{ display: "none" }}
        defaultValue={0}
        readOnly
      />

      <CustomDateTimeInput
        source="rankingDate"
        label="Дата на класиране"
        readOnly={isDisabled}
        required
        validate={[
          required("Полето е задължително"),
          () => {
            if (rankingDate && prevEnrollmentEndDate && rankingDate <= prevEnrollmentEndDate) {
              return "Дата на класиране трябва да е след края на записване от предходното класиране";
            }
            if (
              rankingDate &&
              !prevEnrollmentEndDate &&
              lastExamStartTimestamp &&
              lastExamStartTimestamp >= rankingDate
            ) {
              return "Дата на класиране трябва да е след последната дата на изпит";
            }
            if (registrationTo && !prevEnrollmentEndDate && registrationTo >= rankingDate) {
              return "Датата на класиране трябва да е след датата за край на кампания";
            }
            return undefined;
          },
        ]}
      />

      <CustomDateTimeInput
        source="enrollmentStartDate"
        label="Начало на записване"
        readOnly={isDisabled}
        required
        validate={[
          required("Полето е задължително"),
          () => {
            if (rankingDate && enrollmentStartDate && rankingDate >= enrollmentStartDate) {
              return "Начало на записване трябва да е след датата на класиране";
            }
            if (enrollmentStartDate && enrollmentEndDate && enrollmentStartDate >= enrollmentEndDate) {
              return "Началото трябва да е преди края на записване";
            }
            return undefined;
          },
        ]}
      />

      <CustomDateTimeInput
        source="enrollmentEndDate"
        label="Край на записване"
        readOnly={isDisabled}
        required
        validate={[
          required("Полето е задължително"),
          () => {
            if (enrollmentStartDate && enrollmentEndDate && enrollmentStartDate >= enrollmentEndDate) {
              return "Краят трябва да е след началото на записване";
            }
            return undefined;
          },
        ]}
      />
    </>
  );
};

const RankingsInput = ({ isDisabled }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("lg"));

  return (
    <>
      <Grid
        item
        xs={12}
      >
        <Typography color="primary">Класирания</Typography>
      </Grid>

      <Grid
        item
        xs={12}
      >
        <ArrayInput
          source="rankings"
          label=""
        >
          <SimpleFormIterator
            disableReordering
            disableAdd={isDisabled}
            disableRemove={isDisabled}
            inline={!isMobile}
            sx={settings.style.iteratorWithoutGap}
          >
            <RankingFields isDisabled={isDisabled} />
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </>
  );
};

export default RankingsInput;
